export function footerWatermark() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    const watermark = document.querySelector(".footer__watermark svg");
    const footer = document.querySelector("footer");
    if (!watermark || !footer) return;

    // Begin onzichtbaar en iets naar beneden
    gsap.set(watermark, { opacity: 0, y: 0 });

    // Fade-in + zachte omhoogbeweging
    gsap.to(watermark, {
        opacity: 1,
        y: 0,
        duration: 8,
        ease: "power4.out",
        scrollTrigger: {
            trigger: footer,
            start: "top 85%", // pas starten als footer bijna in beeld is
            once: true
        }
    });
}
